import { rfqRequestQuotePageContainerStyles } from "@insite/content-library/Widgets/RfqRequestQuote/RfqRequestQuotePageContainer";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

rfqRequestQuotePageContainerStyles.container = {
    css: css`
        /* stylelint-disable value-no-vendor-prefix */
        display: -ms-grid;
        display: grid;
        padding: 1.5rem 0 0 1.5rem;
        margin: -1.5rem;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        grid-template-columns: minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 1fr);
                    `,
                    null,
                    css`
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        -ms-grid-columns: minmax(0, 1fr) minmax(0, 1fr);
                        grid-template-rows: repeat(5, auto);
                        -ms-grid-rows: auto auto auto auto auto;
                    `,
                    css`
                        grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
                        -ms-grid-columns: minmax(0, 2fr) minmax(0, 1fr);
                    `,
                ],
                "min",
            )}
        .formWrapper {
            padding-bottom: 115px;
        }
    `,
}